import jan from "../assets/images/jan.jpg";
import feb from "../assets/images/feb.jpg";
import mar from "../assets/images/mar.jpg";
import apr from "../assets/images/apr.jpg";
import may from "../assets/images/may.jpg";
import jun from "../assets/images/jun.jpg";
import jul from "../assets/images/jul.jpg";
import aug from "../assets/images/aug.jpg";
import sep from "../assets/images/sep.jpg";
import oct from "../assets/images/oct.jpg";
import nov from "../assets/images/nov.jpg";
import dec from "../assets/images/dec.jpg";

export const MONTH_DATA = [
  { name: "January", image: jan, color: "#6366f1" },
  { name: "February", image: feb, color: "#ec4899" },
  { name: "March", image: mar, color: "#22c55e" },
  { name: "April", image: apr, color: "#f59e0b" },
  { name: "May", image: may, color: "#10b981" },
  { name: "June", image: jun, color: "#3b82f6" },
  { name: "July", image: jul, color: "#ef4444" },
  { name: "August", image: aug, color: "#f97316" },
  { name: "September", image: sep, color: "#84cc16" },
  { name: "October", image: oct, color: "#a855f7" },
  { name: "November", image: nov, color: "#14b8a6" },
  { name: "December", image: dec, color: "#0ea5e9" }
];